<template>
  <div>
    <div class="margin-bottom">
      <Dropdown @on-click="handleCreate">
        <Button type="primary" class="margin-right" icon="md-add">新增</Button>
        <DropdownMenu slot="list">
            <DropdownItem name="primary">主贷人</DropdownItem>
            <DropdownItem name="other">其他类型</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
    <div class="margin-bottom" style="color: #ed4014;">仅限添加一位主贷人，其余类型限两位。</div>
    <sl-table ref="table" :loading="loading" :columns="columns" :data="data" :enable-pager="false"></sl-table>
    <debtor-person-detail ref="item" @on-update="handleUpdate"></debtor-person-detail>
    <debtor-person-primary ref="itemPrimary" @on-update="handleUpdate"></debtor-person-primary>
    
  </div>
</template>
<script>
import debtorPersonDetail from './debtorPersonDetail'
import debtorPersonPrimary from './debtorPersonPrimary'

const columns = [
  {title:'姓名', key:'name'},
  {title:'类型', key:'userTypeText' , width:80},
  {title:'手机号',key:'phone'},
  {title:'状态',key:'stateText'},
  {title:'征信结果',key:'lastBankResult'},
]


export default {
  components: { debtorPersonDetail , debtorPersonPrimary},

  data() {
    return {
      id:null,
      columns:[
        ...columns,
                {
          title: '操作',
          key: 'action',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let acts = []
            if(params.row.state != 1){
              acts.push(h('a', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.ciQuery(params)
                  }
                }
              }, '征信查询'))
            }
            return h('div', [
              h('a', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.edit(params)
                  }
                }
              }, '编辑'),
              ...acts,
              h('a', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.remove(params)
                  }
                }
              }, '删除')
            ])
          }
        }
      ],
      data:[],
      specs:[],
      // page: {
      //   pageNum: 1,
      //   pageSize: 10,
      //   total:0
      // },
      loading:false
    }
  },
  props:{
    orderId:{

    }
  },
  watch:{
    orderId(val){
      if(val){
        this.init()
      }
    }
  },
  created(){
    if( this.orderId ){
      this.init()
    }
  },
  methods: {
    init() {
      if(this.orderId){
        this.list()
      }
    },

    list(){
      this.$request.orderPersons(this.orderId).then(resp => {
        if(resp.code){
          this.$Message.error( resp.msg )
        }else{
          this.data = this.$utils.conv(resp.data || [] , {'userType':'$debtorType' , 'state':'$ciState'})
        }
      })
    },

    handleCreate(type){
      if( type == 'primary' ){
        this.createPrimary()
      }else{
        this.create()
      }
    },
    create(){
      this.$refs['item'].init(this.orderId)
    },
    createPrimary(){
      this.$refs['itemPrimary'].init(this.orderId)
    },
    edit({row}){
      this.$refs['item'].init(this.orderId, row.id )
    },

    remove({row}){
      this.$ui.confirm(this.$request.orderPersonDelete ,  `确定删除 ${row.name} ？`)(row.id).then( resp => {
        if(!resp.code){
          this.$Message.success('删除成功')
          this.list()
        }
      })
    },

    ciQuery({row}){
      let promise = row.state == 2  ? this.$ui.confirm(this.$request.ciQueryByOrder , `${row.name} 已存在征信结果，请确认是否再次查询？`) :  this.$request.ciQueryByOrder

      this.loading = true

      promise(row.orderId , row.personalId).then( resp => {
        this.loading = false
        
        if(!resp.code){
          this.$Message.success(resp.msg)
        }else{
          this.$Modal.error({title:'征信查询' , content:resp.msg})
        }
      } , resp => {
        this.loading = false
      })
    },
    handleSelect(){

    },
    handleChange(){

    },
    handleUpdate(){
      this.list()
    }
  }
}
</script>